// T-153 (v1.8.54, Session 43): Bezug eines Eintrags der E-Mail-Queue für Liste und Detail. Gutschein-Zahlungserinnerungen haben
// keine Buchung, sondern einen Gutschein (voucherCode); Buchungs-Mails bleiben unverändert.
export interface QueueBezug {
  bookingNumber?: string | null;
  voucherCode?: string | null;
}

/** Anzeige in der Spalte "Buchung": Buchungsnummer, sonst "Gutschein GS-...", sonst "-". */
export function queueBezugText(e: QueueBezug): string {
  if (e.bookingNumber && e.bookingNumber.trim()) return e.bookingNumber;
  if (e.voucherCode && e.voucherCode.trim()) return `Gutschein ${e.voucherCode}`;
  return '-';
}

/** Beschriftung im Detail: "Gutschein:" bei Gutschein-Einträgen, sonst "Buchung:". */
export function queueBezugLabel(e: QueueBezug): string {
  return !(e.bookingNumber && e.bookingNumber.trim()) && e.voucherCode && e.voucherCode.trim() ? 'Gutschein:' : 'Buchung:';
}

/** Wert im Detail: Buchungsnummer oder Gutschein-Code. */
export function queueBezugWert(e: QueueBezug): string {
  if (e.bookingNumber && e.bookingNumber.trim()) return e.bookingNumber;
  if (e.voucherCode && e.voucherCode.trim()) return e.voucherCode;
  return '-';
}
